var typographyStyles = theme => {
  return {
    'h1, .title-large, .title-large--light': theme.typography.titleLarge,
    'h2, .title-medium, .title-medium--light': theme.typography.titleMedium,
    'h3, .title-regular, .title-regular--light': theme.typography.titleRegular,
    'h4, .title-small, .title-small--light': theme.typography.titleSmall,
    'h5, .subtitle-large, .subtitle-large--light': theme.typography.subtitleLarge,
    'h6, .subtitle-regular, .subtitle-regular--light': theme.typography.subtitleRegular,
    'body, .body, .body-regular': theme.typography.bodyRegular,
    '.body-large': theme.typography.bodyLarge,
    '.caption, .caption-regular': theme.typography.captionRegular,
    '.caption-small': theme.typography.captionSmall,
    '.label, .label-regular': theme.typography.labelRegular,
    '.label-small': theme.typography.labelSmall,
    '.overline, .overline-regular': theme.typography.overlineRegular,
    '.overline-large': theme.typography.overlineLarge,
    '.font-medium': {
      fontFamily: theme.typography.family0,
      fontWeight: theme.typography.weight4
    }
  };
};
export default typographyStyles;